module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/5@2x_a7daa4f86a886ca0a6fcfbb0e7daffd9.png";